import React from 'react';

import { TableCell, TableRow } from '@material-ui/core';

import { useAssignResultsState } from '../../../../admin/EventWizard/Common/AssignResults/Context/AssignResults.context';
import { getSkinsRowResult } from '../Utils/getSkinsRowResult';

interface IProps {
  hole: string;
  index: number;
  onClick: (index: number) => () => void;
}

export const SimpleSkinsTableRow = (props: IProps) => {
  const { hole, index, onClick } = props;

  const { selectedScoreType, skinsResults, selectedRoundFormat } = useAssignResultsState();

  const holeResults = skinsResults[Number(hole)];

  return (
    <TableRow
      id={`clickableRowResult-${index}`}
      key={`tableRowResult-${index}`}
      onClick={onClick(index)}
    >
      <TableCell className="index">{Number(hole) + 1}</TableCell>
      <TableCell className="playerName">
        {`${holeResults[0].userFirstName[0]}. ${holeResults[0].userLastName}`}
      </TableCell>
      <TableCell className="result">
        {getSkinsRowResult(skinsResults, hole, selectedScoreType, selectedRoundFormat)}
      </TableCell>
      <TableCell className="ribbon-metaContainer">
        <div className="ribbon-container">
          <span className="ribbon">SKIN</span>
        </div>
      </TableCell>
    </TableRow>
  );
};
